import settings from '/@/core/settings';
import { _ } from '/@/locale';
import Title from '/@/v3/components/title';

import styles from '../styles.module.css';

const CatalogBrandHeader = ({ brand, config }) => {
    return (
        <div className={styles.root}>
            {brand && <img className={styles.logo} src={brand.logo} />}
            <div className={styles.description}>
                <Title bolder size='lg' theme={settings.app.theme}>
                    {config && _(config.listTitle)}
                </Title>
                <Title bolder className={styles.subtitle} theme={settings.app.theme}>
                    {config && _(config.listSubtitle)}
                </Title>
                <Title className={styles.text}>{config && _(config.listDescription)}</Title>
            </div>
        </div>
    );
};

export default CatalogBrandHeader;
